import { Link } from "@tanstack/react-router";
import { useSession } from "@/hooks/use-session";
import { useOverlayOpen } from "@/lib/overlay-store";
import { StudentAvatar } from "@/lib/avatars";
import { cn } from "@/lib/utils";

/** Avatar + class/exam chip that links to the profile hub. */
export function ProfileHeaderButton({ className }: { className?: string }) {
  const { profile } = useSession();
  if (!profile) return null;

  const meta = [profile.studyClass, profile.targetExam].filter(Boolean).join(" · ");

  return (
    <Link
      to="/profile"
      aria-label="Open your profile menu"
      className={cn(
        "flex shrink-0 items-center gap-2 rounded-full border border-primary/30 bg-card/70 py-1 pl-1 pr-1 shadow-[0_6px_20px_-8px_rgba(0,0,0,0.5)] backdrop-blur-xl transition-transform active:scale-95",
        meta && "pr-3",
        className,
      )}
    >
      <StudentAvatar id={profile.avatarId} className="size-9" />
      {meta ? (
        <span className="max-w-[9rem] truncate text-[11px] font-medium text-muted-foreground">
          {meta}
        </span>
      ) : null}
    </Link>
  );
}

/** Fixed top-right variant used on every page except the home header. */
export function FloatingProfileHeaderButton() {
  const overlayOpen = useOverlayOpen();
  return (
    <ProfileHeaderButton
      className={cn(
        "fixed right-4 top-3 z-40 transition-opacity duration-300",
        overlayOpen && "pointer-events-none opacity-0",
      )}
    />
  );
}
